import { combineReducers } from '@reduxjs/toolkit';
import { reducer as data } from '../comp/flightCalendarsData';
import { filtersOptions, filtersValues } from '../comp/flightCalendarsFilters';

export default combineReducers({
  data,
  filtersOptions,
  filtersValues,
});
